import { Offer } from '@dgx-pr-spa/shared/util';
import { CurrentPlan } from '@dgx-pr-spa/shared/util';
import { CurrentItem } from '@dgx-pr-spa/shared/util';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-summary',
  templateUrl: './header-summary.component.html',
  styleUrls: ['./header-summary.component.scss'],
})
export class HeaderSummaryComponent {
  @Input() currentItem: CurrentItem;
  @Input() currentPlan: CurrentPlan;
  @Input() offer: Offer;
  @Input() upsellEnabled = true;
}
